import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { CREATE_WHERE_TO_GO_ITEM } from '../graphql/whereToGo';
import WhereToGoForm from '../components/WhereToGoForm';
import { toast } from 'react-hot-toast';

export default function CreateWhereToGo() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const [createWhereToGo, { loading }] = useMutation(CREATE_WHERE_TO_GO_ITEM, {
    onCompleted: () => {
      toast.success('Location created successfully!');
      navigate('/dashboard/where-to-go');
    },
    onError: (error) => {
      setError(error.message);
      toast.error(`Error creating location: ${error.message}`);
    }
  });

  const handleSubmit = async (data) => {
    try {
      setError(null);
      await createWhereToGo({
        variables: {
          input: data
        }
      });
    } catch (err) {
      console.error('Create error:', err);
    }
  };

  return (
    <>
      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 text-red-600 rounded-lg">
          {error}
        </div>
      )}
      <WhereToGoForm
        onSubmit={handleSubmit}
        isLoading={loading}
      />
    </>
  );
} 